<template>
  <a-layout class="login-bg">
    <a-layout-header>
<!--      <img alt="logo" src="@/assets/images/login/logo.png" class="logo">-->
    </a-layout-header>
    <a-layout-content>
      <a-row justify="center" align="middle" type="flex" :gutter="[16,16]" style="height: 100%;">
        <a-col :xs="24" :sm="24" :md="12" :lg="14" :xl="14">
          <div class="desc">
            <h1 class="title">智能选品，选爆款先人一步</h1>
            <h3 class="sub-title">免费选品平台，为达人提供海量爆品和数字化选品服务</h3>
          </div>

        </a-col>
        <a-col :xs="20" :sm="20" :md="10" :lg="8" :xl="8">
          <div class="card">
            <a-tabs default-active-key="login" >
              <a-tab-pane key="login" tab="密码登录">
                <a-form :form="loginForm" >
                  <a-form-item >
                    <a-input v-model="loginForm.phone" placeholder="请输入手机号" class="input" type="number"/>
                  </a-form-item>
                  <a-form-item >
                    <a-input v-model="loginForm.password" class="input" placeholder="请输入密码" type="password"/>
                  </a-form-item>
                  <a-form-item>
                    <div class="button" @click="handleLogin">登录</div>
                  </a-form-item>
                </a-form>
              </a-tab-pane>
              <a-tab-pane key="regist" tab="短信登录/注册" force-render>
                <a-form :form="registForm" >
                  <a-form-item >
                    <a-input v-model="registForm.phone" placeholder="请输入手机号" class="input" type="number"/>
                  </a-form-item>
                  <a-form-item>
                    <a-input v-model="registForm.captcha" class="input" placeholder="请输入验证码">
                      <span v-if="waitTime > 0" slot="suffix" class="getCode" style="color:#aaaaaa;">{{codeBtnWord}}</span>
                      <span v-else slot="suffix" class="getCode" @click="getCode">获取验证码</span>
                    </a-input>
                  </a-form-item>
                  <a-form-item  v-if="register_invite_code_enable || register_invite_code_should_input">
                    <a-input v-model="registForm.invited_code" class="input" :placeholder="'请输入邀请码' + (register_invite_code_should_input ? '(必填)' : '(选填)')"/>
                  </a-form-item>
                  <a-form-item>
                    <div class="button" @click="handleRegist">登录/注册</div>
                  </a-form-item>
                </a-form>
                <div class="privacy">未注册手机号验证后将自动登录</div>
              </a-tab-pane>
            </a-tabs>

            <div class="privacy">
              登录即表示同意
              <span class="link">《服务协议》</span>
              与
              <span class="link">《隐私条款》</span>
            </div>
          </div>
        </a-col>
      </a-row>
    </a-layout-content>
  </a-layout>
</template>

<script>
import MD5 from 'md5'
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('user')
import {sendSmsCode, checkNeedInvitedCode, getUserByCode} from "@/api/user";

export default {
  name: "index",
  data() {
    return {
      bg: require('@/assets/images/login/bg.jpeg'),
      register_invite_code_enable: false,
      register_invite_code_should_input: false,
      codeBtnWord: '获取验证码',
      waitTime: 0,
      loginForm: {
        phone: '',
        password: '',
      },
      registForm: {
        phone: '',
        captcha: '',
        invited_code: '',
        parent_uid: ''
      }
    }
  },
  methods: {
    ...mapActions({ loginByPassword: 'loginByPassword', loginBySms: 'loginBySms'}),
    handleLogin() {
      let params = JSON.parse(JSON.stringify(this.loginForm))
      params['password'] = MD5(params.password).toString()
      this.loginByPassword(params)
    },
    handleRegist() {
      this.registForm.parent_uid = ''
      if (this.register_invite_code_should_input && !this.registForm.invited_code) {
        this.$message.error('请输入邀请码')
        return
      }
      if (this.registForm.invited_code) {
        getUserByCode(this.registForm.invited_code).then(userInfo => {
          console.log(userInfo)
          this.registForm.parent_uid = userInfo.user_id
          this.loginBySms(this.registForm)
        })
      } else {
        this.loginBySms(this.registForm)
      }

    },
    getCode() {
      if (!this.registForm.phone || this.registForm.phone.length === 0 ) {
        this.$message.error('请输入手机号')
        return
      }
      checkNeedInvitedCode(this.registForm).then(res => {
        const { register_invite_code_enable , register_invite_code_should_input} = res
        this.register_invite_code_enable = register_invite_code_enable === '1'
        this.register_invite_code_should_input = register_invite_code_should_input === '1'
      })

      sendSmsCode(this.registForm).then(res => {
        console.log(res)
        this.$message.success('验证码已发送')
        this.codeDown()
      })

    },
    codeDown() {
      this.waitTime = 60;
      this.codeBtnWord = `${this.waitTime}s 后获取`;
      let timer = setInterval(() => {
        if (this.waitTime > 0) {
          this.waitTime--;
          this.codeBtnWord = `${this.waitTime}s 后获取`;
        } else {
          clearInterval(timer);
        }
      }, 1000);
    }
  }

}
</script>

<style scoped lang="scss">
.login-bg {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-image: url(../../assets/images/login/bg.jpeg);
  background-repeat: no-repeat;
  background-size: 100% 100%;

  :deep .ant-layout-header {
    background: #00000000;
  }

  .logo {
    height: 56px;
  }

  .desc {
    padding: 50px;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    //align-items: center;

    .title {
      font-size: 2.71vw;
      color: white;
    }
    .sub-title {
      color: white;
      font-size: 1.76vw;
    }

    @media screen and (max-width: 768px) {
      .title {
        font-size: 20px;
      }
      .sub-title {
        color: white;
        font-size: 16px;
      }
    }
  }

  .card {
    background: #FFFFFF;
    border-radius: 20px;
    padding: 30px;
    overflow: hidden;
    max-width: 440px;

    :deep .ant-tabs-nav-scroll {
      text-align: center;
    }
    :deep .ant-tabs-tab {
      font-size: 20px;
    }
    :deep input {
      height: 50px;
      background: #f1f1f1;
      border-radius: 8px;
    }
    :deep .ant-tabs-nav .ant-tabs-tab-active {
      color: #8D12F8;
      text-shadow: 0 0 0.25px currentColor;
    }
    :deep .ant-tabs-ink-bar {
      position: absolute;
      bottom: 1px;
      left: 0;
      z-index: 1;
      box-sizing: border-box;
      width: 30px;
      height: 2px;
      border-radius: 2px;
      background-color: #950BFF;
      transform-origin: 0 0;
    }


    .getCode {
      font-size: 14px;
      color: #950BFF;
      line-height: 20px;
      cursor: pointer;
    }

    .button {
      width: 100%;
      height: 60px;
      background: linear-gradient(228deg, #6E53EE 0%, #5B88F5 100%);
      border-radius: 7px;
      font-size: 16px;
      color: #FFFFFF;
      line-height: 60px;
      text-align: center;
      cursor: pointer;
    }

    .privacy {
      font-size: 12px;
      color: #ABABAB;
      line-height: 17px;
      text-align: center;

      .link {
        color: black;
      }
    }
  }
}
</style>
